import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit ,AfterViewInit, ViewChild,ElementRef } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ToastrService } from 'ngx-toastr';



@Component({
    selector: 'app-popup-modal',
    templateUrl: './popup-modal.component.html',
    styleUrls: ['./popup-modal.component.scss'],
})

export class PopupModalComponent implements OnInit, AfterViewInit  {
    public active: boolean = false;
    public nameParent: string;
    public title: string;
    public name: string;
    public onClose: Subject<boolean>;
    public action = null;
    public isEdit = false;
    public isAdd = false;
    public isAddRoot = false;
    public isDel = false;
    usernameErrorMsg = '';
    @ViewChild('nameRef') nameRef: ElementRef;

    public constructor(
        private _bsModalRef: BsModalRef,
        private toastrService: ToastrService,
    ) { }
    ngAfterViewInit() {

    }

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public showPopupModal(action: string, title: string, nameParent: string, name: string): void {
        this.title = title;
        this.nameParent =  nameParent;
        this.name = name;
        this.action = action;
        this.active = true;
        if(action =='ADD'){
            this.isAdd = true;
            this.isDel = false;
            this.isEdit = false;
            this.isAddRoot = false;
        }

        if(action =='EDIT'){
            this.isEdit = true;
            this.isAddRoot = false;
            this.isDel = false;
            this.isAdd = false;
        }

        if(action =='DELETE'){
            this.isDel = true;
            this.isEdit = false;
            this.isAddRoot = false;
            this.isAdd = false;
        }

        if(action =='ADD_ROOT'){
            this.isAddRoot = true;
            this.isAdd = false;
            this.isDel = false;
            this.isEdit = false;

        }
    }

    public onConfirm(): void {
        this.active = false;
        this.onClose.next(true);
        this._bsModalRef.hide();
    }

    public onCancel(): void {
        console.log('onCancel  info');
        this.active = false;
        this.onClose.next(false);
        this._bsModalRef.hide();
    }


    // public onCreate(): void {
    //     console.log('onCreate  info');
    //     console.log(this.nameRef.nativeElement.value);
    //     console.log(this.nameParent);
    //     if (this.nameRef.nativeElement.value === '') {
    //         this.usernameErrorMsg = 'Tên phòng ban không được để trống';
    //     }else{
    //         this.onClose.next(true);
    //         this._bsModalRef.hide();
    //     }
    // }

    public onCreate(): void {
        console.log('onCreate  info');
        console.log(this.nameRef.nativeElement.value);
        console.log(this.nameParent);
        if (this.nameRef.nativeElement.value === '') {
            this.usernameErrorMsg = 'Tên phòng ban không được để trống';
            this.toastrService.warning('Chưa đủ thông tin hoặc thông tin không chính xác!', 'Cảnh báo');
        }else{
            this.onClose.next(true);
            this._bsModalRef.hide();
        }
    }

    public onUpdate(): void {
        console.log('onUpdate  info');
        console.log(this.nameRef.nativeElement.value);
        if (this.nameRef.nativeElement.value === '') {
            this.usernameErrorMsg = 'Tên phòng ban không được để trống';
            this.toastrService.warning('Chưa đủ thông tin hoặc thông tin không chính xác!', 'Cảnh báo');
        }else{
            this.onClose.next(true);
            this._bsModalRef.hide();
        }
    }


    public onDelete(): void {
        console.log('onDelete  info');
        this.onClose.next(true);
        this._bsModalRef.hide();
    }


    public hidePopupModal(): void {
        console.log('hidePopupModal  info');
        this.active = false;
        this.onClose.next(null);
        this._bsModalRef.hide();
    }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/system/departments/popup-modal.component.ts